import { render, staticRenderFns } from "./AddPaper.vue?vue&type=template&id=e08bfa60&scoped=true"
import script from "./AddPaper.vue?vue&type=script&lang=js"
export * from "./AddPaper.vue?vue&type=script&lang=js"
import style0 from "./AddPaper.vue?vue&type=style&index=0&id=e08bfa60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08bfa60",
  null
  
)

export default component.exports